import { FormUnit } from "@suse-o11y/signal/form";

import { isArrayEqual } from "~/tools/is-array-equal";

import type { DashboardSpec } from "../../../../common/dashboard-spec";

export function initVariablesFormState(spec: DashboardSpec) {
	return FormUnit(spec.variables, {
		isInputEqual: (left, right) => isArrayEqual(left, right, (varLeft, varRight) => varLeft.isEqual(varRight)),
	});
}

export type FormState = ReturnType<typeof initVariablesFormState>;
